<template>
  <v-container fluid>
    <data-table
      :filters="filters"
      :limit="10"
      url="/chat_categories"
      content="ChatCategoriesList"
      class="mb-5">
      <template slot="title">
        <v-layout row wrap>
          <v-flex md9>
            <p class="headline mt-3">
              Categorias de chat
            </p>
          </v-flex>
          <v-flex md3 class="text-xs-right">
            <v-btn class="k-orange-linear white--text mt-2 mr-0" large @click="dialog = !dialog">
              CREAR CATEGORIA
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
      <template slot="navigation-bar">
        <v-flex lg10>
          <v-text-field
            v-model="filters.search"
            label="Buscar..."
            color="black"
            solo>
          </v-text-field>
        </v-flex>
        <v-flex lg2 pl-2>
          <v-select
            v-model="filters.type"
            :items="filterTypes"
            color="grey"
            solo>
          </v-select>
        </v-flex>
      </template>
    </data-table>
    <save-dialog
      :title="title"
      :dialog="dialog"
      :form="form"
      :route="route"
      :edit="edit"
      :hasMore="false"
      :more="false">
      <template slot="content">
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
              v-model="form.name"
              v-validate="'required|max:100'"
              data-vv-name="name"
              data-vv-as="nombre"
              :error-messages="errors.collect('name')"
              label="Nombre"
              color="black">
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md12>
            <v-select
              v-model="form.type"
              :items="types"
              v-validate="'required|max:45'"
              data-vv-name="type"
              data-vv-as="tipo"
              :error-messages="errors.collect('type')"
              label="Tipo"
              color="black"
              :disabled="edit && !canChangeType">
            </v-select>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="form.type === 'unsolved'">
          <v-flex md12>
            <v-text-field
              v-model="form.days"
              v-validate="'required|max:100'"
              data-vv-name="days"
              min="0"
              data-vv-as="Días para cerrar"
              :error-messages="errors.collect('days')"
              label="Días para cerrar chat"
              type="number"
              color="black"/>
          </v-flex>
        </v-layout>
      </template>
    </save-dialog>
    <delete-dialog
      :text="deleteOptions.text"
      :id="deleteOptions.id"
      url="chat_categories"
      :dialog="deleteOptions.dialog"
      :delete-bus="deleteBus">
    </delete-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import DataTable from '@/components/global/DataTable';
import SaveDialog from '@/components/global/SaveDialog';
import saveDialogMixin from '@/mixins/saveDialog';
import ChatCategoriesList from '@/components/chat_category/ChatCategoriesList';
import DeleteDialog from '@/components/global/DeleteDialog';
import deleteDialogMixin from '@/mixins/deleteDialog';
import EventBus from '@/event-bus';

Vue.component('ChatCategoriesList', ChatCategoriesList);

export default {
  components: {
    DataTable,
    SaveDialog,
    DeleteDialog,
  },
  mixins: [
    saveDialogMixin,
    deleteDialogMixin,
  ],
  created() {
    EventBus.$on('elementFound', (element) => {
      this.canChangeType = element.can_change_type;
    });
  },
  destroyed() {
    EventBus.$off('elementFound');
  },
  data() {
    return {
      filters: {
        search: '',
        type: '',
      },
      types: [
        {
          value: 'payment_promise',
          text: 'Compromiso',
        },
        {
          value: 'next_contact',
          text: 'Próximo contacto',
        },
        {
          value: 'movement',
          text: 'Movimiento',
        },
        {
          value: 'black_list',
          text: 'Lista negra',
        },
        {
          value: 'unsolved',
          text: 'Sin resolver',
        },
      ],
      form: {
        name: '',
        type: '',
        days: '',
      },
      route: 'chat_categories',
      showName: 'categoria de chat',
      canChangeType: false,
    };
  },
  computed: {
    filterTypes() {
      const empty = [
        {
          value: '',
          text: 'Tipo',
        },
      ];

      return _.concat(empty, this.types);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_category/Index.vue